import { type VariantProps, cva } from 'class-variance-authority'

export { default as RadioCardGroup } from './RadioCardGroup.vue'
export { default as RadioButtonGroup } from './RadioButtonGroup.vue'
export { default as RadioCard } from './RadioCard.vue'
export { default as RadioButton } from './RadioButton.vue'


export const radioButtonGroupVariants = cva(
    'space-y-default',
    {
        variants: {
            variant: {
                default: '',
                inline: 'sm:flex sm:items-center sm:space-x-5 sm:space-y-0',
            },
            description: {
                default: '',
                inline: '',
            }
        },
        defaultVariants: {
            variant: 'default',
            description: 'default',
        },
    },
)

export const radioCardGroupVariants = cva(
    'grid gap-default',
    {
        variants: {
            cols: {
                1: 'sm:grid-cols-1',
                2: 'sm:grid-cols-2',
                3: 'sm:grid-cols-3',
                4: 'sm:grid-cols-4',
                5: 'sm:grid-cols-5',
                6: 'sm:grid-cols-6',
                7: 'sm:grid-cols-7',
                8: 'sm:grid-cols-8',
                9: 'sm:grid-cols-9',
                10: 'sm:grid-cols-10',
                11: 'sm:grid-cols-11',
                12: 'sm:grid-cols-12',
            },
            mobileCols: {
                1: 'grid-cols-1',
                2: 'grid-cols-2',
                3: 'grid-cols-3',
                4: 'grid-cols-4',
                5: 'grid-cols-5',
                6: 'grid-cols-6',
                7: 'grid-cols-7',
                8: 'grid-cols-8',
                9: 'grid-cols-9',
                10: 'grid-cols-10',
                11: 'grid-cols-11',
                12: 'grid-cols-12',
            },
        },
        defaultVariants: {
            cols: 4,
            mobileCols: 1,
        },
    },
)

export type RadioButtonGroupVariants = VariantProps<typeof radioButtonGroupVariants>
export type RadioCardGroupVariants = VariantProps<typeof radioCardGroupVariants>
